import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "arrow",
  "use": "arrow-usage",
  "viewBox": "0 0 8 13",
  "content": "<symbol viewBox=\"0 0 8 13\" xmlns=\"http://www.w3.org/2000/svg\" id=\"arrow\"><path d=\"M101.6 514L100 515.625 104.8008 520.5 100 525.375 101.6 527 108 520.5z\" transform=\"translate(-100 -514)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/svg/arrow.svg
// module id = 47
// module chunks = 0